(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomAssetTypeAttributeDeleteController',CustomAssetTypeAttributeDeleteController);

    CustomAssetTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomAssetTypeAttribute'];

    function CustomAssetTypeAttributeDeleteController($uibModalInstance, entity, CustomAssetTypeAttribute) {
        var vm = this;

        vm.customAssetTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomAssetTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
